{
    "columns":[
		{
			"header_id": "batchName",
			"header_label": "Batch Name",
			"jsonpath":  "batchName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "batchStatusDesc",
			"header_label": "Batch Status",
			"jsonpath":  "batchStatusDesc" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "batchClaimtypeDesc",
			"header_label": "Claim Type",
			"jsonpath":  "batchClaimtypeDesc" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "recordCount",
			"header_label": "Record Count",
			"jsonpath":  "recordCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoCount",
			"header_label": "MCO Count",
			"jsonpath":  "mcoCount" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
		{
			"header_id": "mcoName",
			"header_label": "MCO Name",
			"jsonpath":  "mcoName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "excludeMcoList",
			"header_label": "Exclude MCO List",
			"jsonpath":  "excludeMcoList" ,
			"isDisplayedAtHeader": "n",
			"isSearchable": "n"
		},
		{
			"header_id": "runId",
			"header_label": "Run ID",
			"jsonpath":  "runId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "timesheetCount",
			"header_label": "Timesheet Count",
			"jsonpath":  "timesheetCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "ignoredTimesheetCount",
			"header_label": "Ignored Timesheet Count",
			"jsonpath":  "ignoredTimesheetCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "totalCharges",
			"header_label": "Total Charges",
			"jsonpath":  "totalCharges" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "createddate",
			"header_label": "Created Date",
			"jsonpath":  "createddate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "pmpmFlg",
			"header_label": "PMPM",
			"jsonpath":  "pmpmFlg" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "batches.json",
	"pageName": "billing-batch-master-list",
	"orderByColumn": ["createddate"],
	"orderBy": ["desc"]
}